var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"button-back-to-top",attrs:{"href":"#"},on:{"click":function($event){return _vm.scrollToTop()}}},[_c('div',{staticClass:"label"},[_vm._v("Retour en haut de page")]),_vm._v(" "),_c('svg',{staticClass:"icon-arrow"},[_c('use',{attrs:{"xlink:href":"#icon-arrow2"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }